import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ToastState {
  message: string;
  type: "success" | "error";
  title?: string;
  onClose?: () => void;

}

const initialState = null as ToastState | null;

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    setToast: (_state, action: PayloadAction<ToastState>) => action.payload,
    clearToast: () => null as ToastState | null,
  },
});

export const { setToast, clearToast } = toastSlice.actions;
export default toastSlice.reducer;
